const goodsRoutes = [
  {
    path: '/goods-category',
    name: 'GoodsCategory',
    meta: {
      index: 2
    },
    component: () => import('@/views/goods/goodsCategory/Index.vue')
  },
  {
    path: '/goods-list',
    name: 'GoodsList',
    meta: {
      index: 3
    },
    component: () => import('@/views/goods/goodsList/Index.vue')
  },
  {
    path: '/mall',
    name: 'Mall',
    meta: {
      index: 3
    },
    component: () => import('@/views/mall/Index.vue')
  },
  {
    path: '/third-mall',
    name: 'ThirdMall',
    title: '花豹商城',
    meta: {
      index: 3,
      title: '花豹商城'
    },
    component: () => import('@/views/thirdMall/Index.vue')
  },
  {
    path: '/third-mall/detail',
    name: 'ThirdMallDetail',
    title: '商品详情',
    meta: {
      index: 38,
      title: '商品详情'
    },
    component: () => import('@/views/thirdMall/Detail.vue')
  },
  {
    path: '/goods-detail',
    name: 'GoodsDetail',
    meta: {
      index: 38
    },
    component: () => import('@/views/goods/goodsDetail/Index.vue')
  },
  {
    path: '/shopping-cart',
    name: 'ShoppingCart',
    meta: {
      index: 40
    },
    component: () => import('@/views/my/shoppingCart/Index.vue')
  },
  {
    path: '/order-confirm',
    name: 'OrderConfirm',
    meta: {
      index: 50
    },
    component: () => import('@/views/goods/orderConfirm/Index.vue')
  },
  {
    path: '/goods-coupon',
    name: 'GoodsCoupon',
    meta: {
      index: 38
    },
    component: () => import('@/views/goods/goodsDetail/CouponBenefit')
  },
  {
    path: '/goods-tele',
    name: 'GoodsDetailTele',
    meta: {
      index: 35
    },
    component: () => import('@/views/goods/goodsDetail/TelePhone')
  }
]
export default goodsRoutes
